module.exports = __webpack_public_path__ + "fa-brands-400.woff2?68a68036d1804de9dd28565a4b860933";